// 报名页api

import axios from '../utils/fetch';


// 发送验证码
export const sendVerificateCode = (options) => {
  return axios.post('/api/zmbiz-clue-admin/api/common/sendVerificateCode', options);
};

// 获取老师姓名
export const getCNameForCCB = (options) => {
  return axios.postSign('/api/zmbiz-teacher-h5-api/agent/v3/getCNameForCCB', options);
};
// 发送验证码接口
export const sendMsgForCCB = (options) => {
  return axios.postSign('/api/zmbiz-teacher-h5-api/api/geetest/validateAndSendMsgForCCB', options);
};

export const checkPhoneForCCB = (options) => {
  return axios.postSign('/api/zmbiz-teacher-h5-api/agent/v3/checkPhoneForCCB', options);
};

export const regChannelForCCB = (options) => {
  return axios.postSign('/api/zmbiz-teacher-h5-api/agent/v3/regChannelForCCB', options);
};
